import { Box, Container, Radio } from '@mui/material';
import React, { useEffect, useState } from 'react';
import './InvitationReminder.css';
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CustomButton from '../../Components/Button/Button';
import { GetAllEntitiesForUserAdmin, SendInvitationAndReminder } from '../../Reducers/dcoi';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, TextField } from '@mui/material';
import Toster from '../../Components/Common/Toster/Toster';

function InvitationReminder() {
  const { AllEntitiesForUserAdmin } = useSelector(
    (state) => state.dcoi
  );
  const [severity, setSavirity] = useState();
  const [alert, setAlert] = useState();
  const [message, setMessage] = useState();
  const [error, setError] = useState('');
  const [selectedEntities, setSelectedEntities] = useState([]);
  const [selectedRadio, setSelectedRadio] = useState('SendInvitation');
  const [emailList, setEmailList] = useState('');
  const [emailArray, setEmailArray] = useState([]);

  const allSelected =
    AllEntitiesForUserAdmin.length > 0 &&
    selectedEntities.length === AllEntitiesForUserAdmin.length;

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedEntities(AllEntitiesForUserAdmin.map((entity) => entity.id));
    } else {
      setSelectedEntities([]);
    }
  };

  const handleToggle = (id) => {
    setSelectedEntities((prevSelected) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((entityId) => entityId !== id);
      } else {
        return [...prevSelected, id];
      }
    });
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GetAllEntitiesForUserAdmin());
  }, []);

  const handleRadioChange = (value) => {
    setSelectedRadio(value);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmailList(value);
  
    // Split the emails and trim spaces
    const emails = value.split(';').map(email => email.trim()).filter(email => email);
  
    // Regular expression for validating email addresses
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
    // Check for invalid emails
    const invalidEmails = emails.filter(email => !emailRegex.test(email));
  
    if (invalidEmails.length > 0) {
      setError(`Invalid email(s): ${invalidEmails.join(', ')}`);
      return;
    }
  
    // Remove duplicates
    const uniqueEmails = Array.from(new Set(emails));
  
    if (emails.length > uniqueEmails.length) {
      setError('Duplicate emails are not allowed.');
    } else {
      setError('');
    }
  
    setEmailArray(uniqueEmails);
  };
  

  const handleSubmit = () => {
    const payload = {
      entitieIds: selectedEntities,
      emailIds: emailArray,
      isOption: selectedRadio
    }
    try {
      dispatch(SendInvitationAndReminder(payload)).then((res) => {
        if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
          setAlert(true);
          setSavirity("success");
          setMessage(res?.payload?.data[0]?.success)
          setSelectedEntities([]);
          setEmailList('');
          setEmailArray([]);
        }

        if (res?.payload?.data[0]?.status === "error") {
          setAlert(true);
          setSavirity("error");
          setMessage(res?.payload?.data[0]?.error)
        }
      });
    } catch (error) {
      setAlert(true);
      setSavirity("error");
      setMessage(error)
    }
  }


  return (
    <Container maxWidth="lg">
      <Toster message={message} severity={severity} alert={alert} setAlert={setAlert} />
      <Box className="boxAlignment" sx={{ p: { xs: 2, sm: 3 } }}>
        <Grid container spacing={0} alignItems="center" sx={{ mb: 2 }}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
              <Radio
                size="small"
                checked={selectedRadio === 'SendInvitation'}
                onChange={() => handleRadioChange('SendInvitation')}
              />
              <Typography variant="body1">Send Invitation</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
              <Radio
                size="small"
                checked={selectedRadio === 'SendReminder'}
                onChange={() => handleRadioChange('SendReminder')}
              />
              <Typography variant="body1">Send Reminder to Unsubmitted Users</Typography>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ fontWeight: "bolder", mt: 2, mb: 1 }}>Email <span className='required'>*</span></Box>
        <Box sx={{ mb: 2 }}>
        <TextField
    placeholder="Enter Email, e.g: user1@example.com; user2@example.com"
    fullWidth
    variant="outlined"
    value={emailList}
    onChange={handleEmailChange}
    error={!!error} // Apply error styling if error exists
    helperText={error} // Display error message
    sx={{ mb: 2 }}
  />
</Box>


        <Box sx={{ fontWeight: 'bolder', mt: 2, mb: 1 }}>Entity <span className='required'>*</span></Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={{ backgroundColor: 'white', padding: '20px', borderRadius: '4px' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Checkbox
                  size="small"
                  checked={allSelected}
                  onChange={handleSelectAll}
                />
                <Typography sx={{ ml: 1 }}>Select All Entity</Typography>
              </Box>
              <Box sx={{ ml: 3 }}>
                {AllEntitiesForUserAdmin.map((entity) => (
                  <Box key={`${entity.id}-${Math.random()}`} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Checkbox
                      size="small"
                      checked={selectedEntities.includes(entity.id)}
                      onChange={() => handleToggle(entity.id)}
                    />
                    <Typography sx={{ ml: 1 }}>
                      {entity.Label}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ textAlign: { xs: 'center', sm: 'left' }, mt: 2 }}>
            <CustomButton
              label={selectedRadio==="SendInvitation" ? "Send Invitation" :"Send Reminder" }
              isDisabled={selectedEntities.length === 0 || !selectedRadio}
              onClick={handleSubmit}
            />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default InvitationReminder;
